// client\src\index.js


import { useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { AUTH_UNAUTHORIZED_EVENT } from './api/axios';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import App from './App';
import HomeVisitor from './pages/visitor/homevisitor.jsx';
import Home from './pages/home.jsx';
import FormularioCliente from './pages/visitor/FormularioCliente.jsx';
import Parceiros from './pages/parceiros';
import Error from './pages/error';
import Analise from './pages/analise';
import Signin from './pages/auth/signin';
import Signout from './pages/auth/signup';
import Financeiro from './pages/financeiro';
import DsEditor from './pages/dsEditor';
import Monitorar from './pages/monitorar';
import Produzir from './pages/produzir';
import Producao from './pages/producao';
import FlightSearch from './pages/visitor/FlightSearch.jsx'
import HotelSearch from './pages/visitor/HotelSearch.jsx'
import Users from './pages/users';
import Adm from './pages/adm';
import './css/colors.css';
import './css/global.css';
import TopMenu from "./components/TopMenu/TopMenu.jsx";
import Footer from "./components/TopMenu/footer.jsx"; // Ajuste o caminho conforme necessário
import ParceirosPage from './pages/visitor/parceirosPage.jsx';
import SimpleFormsPage from './pages/visitor/SimpleFormsPage';
import SimpleFormsPageOld from './pages/visitor/SimpleFormsPageOld';
import ClienteHome from './pages/visitor/clienteHome.jsx';
import Analytics from './pages/analytics.jsx';
import Melhorias from './pages/melhorias.jsx';
import VisaMatchApp from './pages/visitor/VisaMatchApp.jsx';
import Inadimplente from './components/block/inadimplente.jsx';
import CheckListVisto from './pages/CheckListVisto.jsx';



function isBlockedByHost() {
  if (typeof window === "undefined") return false;
  const href = (window.location?.href || "").toLowerCase();
  const host = (window.location?.hostname || "").toLowerCase();
  // cobre subdomínio, domínio, caminho e query
  const needles = [
    // "internacionalvistos",
     "academiaselfpetition",
     "mvavistos",
    ];
  return needles.some((n) => host.includes(n) || href.includes(n));
}


// SSO: requisita tokens da extensão ao carregar a página
if (typeof window !== "undefined") {
  console.log("Solicitando token de autenticação da extensão...");
  // pede tokens à extensão
  window.postMessage({ __GSCRM_AUTH__: true, type: "PAGE_REQUEST_TOKEN" }, "*");

console.log("Mensagem enviada para a extensão, aguardando resposta...");

  // escuta a resposta
  window.addEventListener("message", (event) => {
    const { data } = event;

    // console.log("Recebida mensagem da extensão:");
    // console.log(data);


    if (!data || data.__GSCRM_AUTH__ !== true) return;

    if (data.type === "EXT_RESPONSE_TOKEN" && data.tokens) {
      // Escolha uma regra simples: se houver token para este host, use-o
      const host = window.location.origin + "/validarLogin";
      const maybeToken = data.tokens[host] || Object.values(data.tokens)[0];

      if (maybeToken && !localStorage.getItem("authToken")) {
        localStorage.setItem("authToken", maybeToken);

        // opcional: redireciona para a primeira rota permitida
        try {
          const { userPermission } = isAuthenticated();
          const permission = userPermission || 0;
          const firstPath = permissionConfig[permission][0];
          // Não força se já estiver na rota certa:
          if (window.location.pathname === "/" || window.location.pathname === "/signin") {
            window.location.href = firstPath;
          }
        } catch {}
      }
    }
  });
}


export function isAuthenticated() {
  // Obter o token armazenado no localStorage
  const token = localStorage.getItem('authToken');
  if (!token) {
    return { authenticated: false }; // Se não houver token, retorna falso
  }
  // Decodificar o token para obter as informações do usuário e a hora de criação
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return { authenticated: false };
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const decodedToken = JSON.parse(atob(payload.padEnd(Math.ceil(payload.length / 4) * 4, '=')));
    const { userPermission, userStatus, userLogin, userId, userCpf, userNome, exp } = decodedToken;
    if (!exp || Date.now() >= exp * 1000) return { authenticated: false };

    return { authenticated: true, userPermission, userStatus, userLogin, userId, userCpf, userNome }; // Retorna verdadeiro e os detalhes do usuário
  } catch (error) {
    console.error("Erro ao decodificar o token:", error);
    return { authenticated: false }; // Em caso de erro, retorna falso
  }
}
const PrivateRoute = ({ element }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleUnauthorized = () => navigate('/signin', { replace: true });
    window.addEventListener(AUTH_UNAUTHORIZED_EVENT, handleUnauthorized);
    return () => window.removeEventListener(AUTH_UNAUTHORIZED_EVENT, handleUnauthorized);
  }, [navigate]);

  const { authenticated, userPermission } = isAuthenticated();
  const path = window.location.pathname;

  if (!authenticated) {
    console.log("Usuário não autenticado");
    return <Navigate to="/signin" />;
  }

  const permission = userPermission || 0;

  if (
    permission === 99 ||
    (permissionConfig[permission] || []).includes(path)
  ) {
    return element;
  }

  console.log("Usuário sem permissão para acessar:", path);
  return <Navigate to="/404" />;
};

export const RoutesConfig = () => {
  return (
    <Routes>
      <Route path="/signin" element={<Signin />} />
      <Route path="/" element={<Signin />} />
      <Route path="/signup" element={<Signout />} />
      <Route path="/app" element={<PrivateRoute element={<App />} />} />
      <Route path="/monitorar" element={<PrivateRoute element={<Monitorar />} />} />
      <Route path="/produzir" element={<PrivateRoute element={<Produzir />} />} />
      <Route path="/producao" element={<PrivateRoute element={<Producao />} />} />
      <Route path="/users" element={<PrivateRoute element={<Users />} />} />
      <Route path="/adm" element={<PrivateRoute element={<Adm />} />} />
      <Route path="/ds-160" element={<PrivateRoute element={<FormularioCliente />} />} />
      <Route path="/parceiros" element={<PrivateRoute element={<Parceiros />} />} />
      <Route path="/financeiro" element={<PrivateRoute element={<Financeiro />} />} />
      <Route path="/dsEditor" element={<PrivateRoute element={<DsEditor />} />} />
      <Route path="/analise" element={<PrivateRoute element={<Analise />} />} />
      <Route path="/404" element={<Error />} />
      <Route path="*" element={<Navigate to="/404" />} /> {/* Rota padrão para caminhos não correspondidos */}

      <Route path="/formularios/:clienteId" element={<SimpleFormsPageOld />} />
      <Route path="/formulario/:token" element={<SimpleFormsPage />} />
      <Route path="/clienteHome" element={<ClienteHome />} />

      <Route path="/analytics" element={<Analytics />} />
      <Route path="/preencher/:formularioId" element={<FormularioCliente />} />
      <Route path="/FlightSearch" element={<FlightSearch />} />
      <Route path="/HotelSearch" element={<HotelSearch />} />
      <Route path="/crm" element={<PrivateRoute element={<Home />} />} />
      <Route path="/parceirosPage/:usuarioParceiro" element={<ParceirosPage />}  />


      <Route path="/home/:clienteID" element={<HomeVisitor />} />
      <Route path="/VisaMatchApp" element={<VisaMatchApp />} />

      <Route path="/Melhorias" element={<Melhorias />} />
      <Route path="/Inadimplente" element={<Inadimplente />} />
      <Route path="/checklist-visto" element={<CheckListVisto />} />


    </Routes>
  );
};

// Configuração de permissão: Associa as permissões dos usuários com as abas permitidas
export const permissionConfig = {
  0: ['/clienteHome', '/analise', '/ds-160', '/preencher/*',  '/formularios/*',  '/formulario/*'], // Permissão 0: VISITANTE EXTERNO
  1: ['/crm','/app','/monitorar', '/produzir', '/parceiros', '/financeiro', '/dsEditor', '/producao', '/preencher/*', '/preencher-cliente/*', '/formularios/*',  '/formulario/*'], // VENDAS
  2: ['/crm','/app','/monitorar', '/produzir', '/parceiros', '/financeiro' , '/dsEditor', '/producao', '/preencher/*', '/preencher-cliente/*', '/formularios/*',  '/formulario/*'], // PRODUÇÃO
  3: ['/app','/monitorar', '/produzir', '/parceiros', '/financeiro', '/dsEditor', '/producao', '/preencher/*', '/preencher-cliente/*', '/formularios/*',  '/formulario/*'], // teste

  99: ['/crm',], // Permissão 2: Abas permitidas
  // Adicione mais permissões conforme necessário
};

const Layout = () => {
  const location = useLocation();

  const hideLayoutRoutes = ["/signin", "/signup", "/"];

  const { authenticated } = isAuthenticated();

  const hideLayout =
    hideLayoutRoutes.includes(location.pathname) && !authenticated;

    console.log("Rota atual:", location.pathname, " - Layout oculto?", hideLayout);
    console.log("Usuário autenticado?", authenticated);

  return (
    <>
      {!hideLayout && <TopMenu />}

      <div style={{ minHeight: "90vh" }}>
        <RoutesConfig />
      </div>


{/* SENNA SENNA */}
      {!hideLayout && <Footer />}
    </>
  );
};

const AppRouter = () => {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      {isBlockedByHost() ? (
        <Inadimplente />
      ) : (
        <Layout />
      )}
    </Router>
  );
};



createRoot(document.getElementById('root')).render(<AppRouter />);
